import React, { useContext } from 'react'
import { UserContext } from '../../App';
import { Navigate, Route, Routes } from 'react-router-dom';
import { SchoolDashBoard } from '../SchoolDashboard';
import { ManageTicket } from '../ManageTicket';
import RepairDetails from '../../Components/RepairDetails';
import { ManageDeviceIndex } from '../ManageDevice';
import { IndexUsers } from '../ManageUsers';
import { ImportExport } from '../ImportExport';
import { SchoolReports } from '../SchoolReports';
import { ShipDevices } from '../ShipDevices';
import HelpdeskIndex from '../Helpdesk';
import { MaintenanceSupportTicket } from '../SupportTicket/Maintenance';
import { ManageParts } from '../ManagePart';
import MassTicket from '../MassTicket';
import Outgoingbatches from '../ShipDevices/Outgoingbatches';
import { AddUpdate } from '../ManageDevice/addupdate';
import { UsersAddUpdate } from '../ManageUsers/addupdate';
import { DeviceAllocate } from '../DeviceAllocation';
import ManageSoftware from '../ManageSoftware';
import { SchoolInvoice } from '../SchoolBilling';
import { TechnologySupportTicket } from '../SupportTicket/Technology';
import { ErrorPage } from '../404Error';
import TicketAssignment from '../TicketAssignments';
import RolesIndex from '../Roles';
import SchoolProfile from '../SchoolProfile';
import DeviceCustomField from '../CustomField/Index';
import Helpdeskrequest from '../Helpdesk/Helpdeskrequest';
import HelpdeskTicket from '../Helpdesk/HelpdeskTicket';
import ErrorLogsPage from '../ErrorPage/ErrorLogsPage';
import ShowInvoice from '../SchoolBilling/ShowInvoice';
import TicketHistoryPage from '../Billingandtickets/TicketHistoryPage';
import CoveragePurchased from '../ParentalCoverage/CoveragePurchased';
import Notification from '../Notification';
import { FaqIndex } from '../FAQ';
import { Setting } from '../Setting';
import { CreateTicket } from '../CreateTicket';
import CloseTicketInvoice from '../../Components/CloseTicketInvoice';
import History from '../ParentalCoverage/History';
import AddSetup from '../ParentalCoverage/AddSetup';
import { Setup } from '../ParentalCoverage/setup';
import HdticketAssignments from '../Helpdesk/HdticketAssignments';
import PreviousAudits from '../InventoryAudit/PreviousAudits';
import InventoryAudit from '../InventoryAudit';
import UsersGroup from '../UsersGroup';
import Building from '../Building';
import { StaffMemberIndex } from '../StaffMember';

const componentMap = {
    "dashboard": SchoolDashBoard,
    "manage-tickets": ManageTicket,
    "repair-details": RepairDetails,
    "manage-device": ManageDeviceIndex,
    "manage-parts": ManageParts,
    "users": IndexUsers,
    "import-export": ImportExport,
    "reports": SchoolReports,
    "ship-devices": ShipDevices,
    "helpdesk": HelpdeskIndex,
    "maintenance-support-tickets": MaintenanceSupportTicket,
    "mass-tickets": MassTicket,
    "outgoing-batches": Outgoingbatches,
    "addupdate-device": AddUpdate,
    "addupdate-users": UsersAddUpdate,
    "allocate-devices": DeviceAllocate,
    "manage-software": ManageSoftware,
    "school-invoice": SchoolInvoice,
    "technology-support-tickets": TechnologySupportTicket,
    "ticket-assignments": TicketAssignment,
    "staff-members": StaffMemberIndex,
    "building": Building,
    "users-groups": UsersGroup,
    "inventory-audit": InventoryAudit,
    "previous-audits": PreviousAudits,
    "helpdesk-ticket-assignments": HdticketAssignments,
    "setup": Setup,
    "add-setup": AddSetup,
    "club-history": History,
    "close-ticket-invoice": CloseTicketInvoice,
    "create-ticket": CreateTicket,
    "setting": Setting,
    "faqs": FaqIndex,
    "notifications": Notification,
    "purchases": CoveragePurchased,
    "ticket-history": TicketHistoryPage,
    "generate-invoice": ShowInvoice,
    "error-logs-page": ErrorLogsPage,
    "add-helpdesk": HelpdeskTicket,
    "helpdesk-requests": Helpdeskrequest,
    "custom-field": DeviceCustomField,
    "school-profile": SchoolProfile,
    "roles": RolesIndex
};


export default function CustomAccesses() {
    const { menuData } = useContext(UserContext);
    if (!menuData || menuData.length === 0) {
        return <div className='ps-3 pt-4 font-18'>Loading...</div>; // You can replace this with a spinner or skeleton UI
    }
    const routeDependencies = {
        "manage-tickets": ["repair-details", "create-ticket"],
        "manage-device": ["addupdate-device", "custom-field"],
        "users": ["addupdate-users"],
        "helpdesk": ["helpdesk-requests", "helpdesk-ticket-assignments", "add-helpdesk"],
        "parental-care": ["setup", "add-setup", "club-history"],
        "inventory-audit": ["previous-audits"],
        "school-invoice": ["generate-invoice", "close-ticket-invoice"],
        "maintenance-support-tickets": ["ticket-assignments"],
        "technology-support-tickets": ["ticket-assignments"],
        "setup": ["add-setup"],
        "school-invoice": ["ticket-history"],
    };
    const getAccessibleRoutes = (menu) => {
        let allowedRoutes = new Set();
        let firstAccessibleRoute = null;

        menu.forEach(item => {
            if (item.href && componentMap[item.href]) {
                allowedRoutes.add(item.href);
                if (!firstAccessibleRoute) firstAccessibleRoute = item.href;

                if (routeDependencies[item.href]) {
                    routeDependencies[item.href].forEach(depRoute => allowedRoutes.add(depRoute));
                }
            }

            if (item.Submenu) {
                let hasChild = false;

                item.Submenu.forEach(subItem => {
                    if (subItem.Href && componentMap[subItem.Href]) {
                        allowedRoutes.add(subItem.Href);
                        if (!firstAccessibleRoute) firstAccessibleRoute = subItem.Href;
                        hasChild = true;

                        if (routeDependencies[subItem.Href]) {
                            routeDependencies[subItem.Href].forEach(depRoute => allowedRoutes.add(depRoute));
                        }
                    }
                });

                if (hasChild && item.Href && componentMap[item.Href]) {
                    allowedRoutes.add(item.Href);
                    if (!firstAccessibleRoute) firstAccessibleRoute = item.Href;
                }
            }
        });

        return { routes: Array.from(allowedRoutes), firstRoute: firstAccessibleRoute };
    };

    const { routes: accessibleRoutes, firstRoute } = getAccessibleRoutes(menuData);
    return (
        <Routes>
            {firstRoute && <Route path="/" element={<Navigate to={`/${firstRoute}`} replace />} />}
            {accessibleRoutes.map(route => (
                <Route key={route} path={`/${route}`} element={React.createElement(componentMap[route])} />
            ))}
            <Route path="*" element={<ErrorPage />} />
            <Route path="faqs" element={<FaqIndex />} />
        </Routes>
    )
}
